import { useCallback } from "react";

import { saveAs } from "file-saver";
import toast from "react-hot-toast";

import { getFeedbackPdf } from "@/api/feedback";

/**
 * Callback hook to download feedback PDF for a given workId.
 */
export function useDownloadFeedbackPdf(workId: string, tenant: string) {
  return useCallback(async () => {
    const promise = getFeedbackPdf(workId, tenant).then((blob) =>
      saveAs(blob, `feedback-pdf-${workId}.pdf`)
    );
    toast.promise(promise, {
      loading: "Downloading feedback ...",
      success: "Feedback has been downloaded",
      error: "Download failed. Please try again.",
    });
  }, [workId, tenant]);
}
